import React from 'react';
import NavigateNext from '@mui/icons-material/NavigateNext';
import styles from './ReportBlockMobile.module.scss';
import { Button } from 'tt-ui-lib/core';
import { ReactComponent as DeleteSvg } from '../../../../../../assets/svg/delete.svg';
import { ReactComponent as EditSvg } from '../../../../../../assets/svg/edit.svg';
import RenameInput from 'views/ScoreAndReporting/components/ReportRename/ReportRename';

const ReportBlockMobile = ({ props }) => {
  const {
    draft,
    targetWidth,
    calcLogo,
    editId,
    setEditId,
    onProceedDraft,
    onDelete,
    onRenameDraft,
    onViewClick,
  } = props;

  return (
    <>
      <div key={draft.id} className={styles.rowWrapper}>
        <div className={styles.first}>
          <RenameInput
            id={draft.id}
            name={draft.name}
            onEditClick={() => setEditId(editId === draft.id ? null : draft.id)}
            onEditFinish={onRenameDraft}
            isEditing={editId === draft.id}
          />
          {!!onDelete && (
            <Button type="icon" onClick={() => onDelete(draft)}>
              <DeleteSvg />
            </Button>
          )}
        </div>
        <div className={styles.info}>
          <div className={styles.container}>
            <p className={styles.data}>Reporting period:</p>
            <p className={styles.dataValue}>
              {draft?.reportDate ? draft.periodReportDate.getFullYear() : ''}
            </p>
          </div>
          <div className={styles.container}>
            <p className={styles.dataSecond}>Edited:</p>
            <p className={styles.dataValue}>
              {draft?.updatedAt ? draft.updatedAt.toLocaleDateString() : ''}
            </p>
          </div>
          <div className={styles.container}>
            <p className={styles.dataSecond}>Created:</p>
            <p className={styles.dataValue}>
              {draft?.createdAt ? draft.createdAt.toLocaleDateString() : ''}
            </p>
          </div>
        </div>
        <div className={styles.buttonCont}>
          <Button type="link" onClick={() => onProceedDraft(draft.id)}>
            Proceed
            <NavigateNext />
          </Button>
          <Button
            className={styles.more}
            onClick={() => onViewClick(draft.id)}
            disabled={!draft.canPay}
          >
            Pay
          </Button>
        </div>
      </div>
    </>
  );
};

export default ReportBlockMobile;
